import * as React from 'react';
import styled from 'styled-components';

import { Section } from '@process-advisor/process-miner/modals/discoveryRules/section';
import { DataGrid } from '@process-advisor/process-miner/discoveryRules/dataGrid';
import { SingleBlock } from '@process-advisor/process-miner/slicers/singleBlock';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import '@process-advisor/process-miner/shared/gridStyles.css'

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 400px;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    padding-bottom: 5px;
    margin-top: 10px
`;

const DiscoveryRuleWrapper = styled.div`
    margin-top: 7px;
    margin-bottom: 20px;
`;


export type Row = {};
let dateString

export const DiscoveryRuleDetails = ({discoveryRule,filterSummary}) => {
 
    const [discoveryRuleRows, setDiscoveryRuleRows] = React.useState<Row[]>([]);
    const [modelName, setModelName]  = React.useState('');
    
    React.useEffect(() => {
        setDiscoveryRuleRows(filterSummary);
        setModelName(apiProvider.getModelFileName())

        const currentDate = new Date();
        dateString = currentDate.toDateString();

    }, [filterSummary]);

    return (
            <Wrapper>
                <SingleBlock width="15%">
                    <Section title='Data Model'/>
                </SingleBlock>
                <SingleBlock width="85%">
                    <DiscoveryRuleWrapper>
                        {modelName}
                    </DiscoveryRuleWrapper>
                </SingleBlock>

                <SingleBlock width="15%">
                    <Section title='Date'/>
                </SingleBlock>
                <SingleBlock width="85%">
                    <DiscoveryRuleWrapper>
                        {dateString}
                    </DiscoveryRuleWrapper>
                </SingleBlock>

                <SingleBlock width="15%">
                    <Section title='DiscoveryRule'/>
                </SingleBlock>
                <SingleBlock width="85%">
                    <DiscoveryRuleWrapper>
                        {discoveryRule}
                    </DiscoveryRuleWrapper>
                </SingleBlock>
                <SingleBlock width="15%">
                    <Section title='Criteria:'/>
                </SingleBlock>
                <SingleBlock width="85%">
                <DataGrid
                    rows={discoveryRuleRows}
                    height="110px" />
                </SingleBlock>
            </Wrapper>
    );
};


